import { colors } from 'baseui/tokens';
import stylesColors from 'common/styles/styles.colors';
import { string2money } from 'common/utils/string';
import Text from 'components/elements/text';
import { format } from 'date-fns';
import { SeparatorHorizontal, SeparatorVertical } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

import {
  AirlineContainer,
  AirlineContent,
  Container,
  GuestContent,
  TotalContent,
  TotalItemContent,
} from './styles';
import { TicketOrderFlightPurchaseFormType } from '../form-type';
import { flightPurchaseCalculation } from '../total-calculation';

interface Props {
  parentIdx: number;
  data: TicketOrderFlightPurchaseFormType;
}

export default function SummaryItem(props: Props) {
  const { t } = useTranslation();
  const { parentIdx, data } = props;
  const subtotal = React.useMemo(() => flightPurchaseCalculation(data), [data]);
  return (
    <Container>
      <>
        <Text
          variant="LabelMedium"
          $style={{ color: stylesColors.primaryDefault }}
        >
          {t('ticketOrders:schedule_extra', {
            extra: `${parentIdx + 1}${
              data.bookingCode ? `- ${data.bookingCode}` : ''
            }`,
          })}
        </Text>
        {data.flightPurchaseGuests.map((guest, idx) => (
          <GuestContent key={guest.customId || `${parentIdx}-guest-${idx}`}>
            <Text variant="LabelSmall">{guest.guestName}</Text>
            <SeparatorHorizontal $margin={8} />
            {guest.ticket && (
              <Text variant="LabelSmall" $style={{ color: colors.gray400 }}>
                ({guest.ticket?.toUpperCase()})
              </Text>
            )}
          </GuestContent>
        ))}
        {data.flightPurchaseAirlines.map((airline, idx) => (
          <AirlineContainer
            key={airline.customId || `${parentIdx}-airline-${idx}`}
          >
            <AirlineContent>
              <Text variant="LabelSmall">{`${
                airline.date ? format(airline.date, 'dd-MM-yyyy') : '-'
              } | ${airline.detail} | ${airline.route} | ${
                airline.time
              } `}</Text>
              <SeparatorHorizontal $margin={8} />
              <Text variant="LabelSmall" $style={{ color: colors.gray500 }}>
                {`@ Rp ${string2money(airline.price || 0)}`}
              </Text>
            </AirlineContent>
            <Text variant="LabelSmall">
              {`Rp ${string2money(
                (airline.price || 0) * data.flightPurchaseGuests.length,
              )}`}
            </Text>
          </AirlineContainer>
        ))}
        {!!data.flightPurchaseAddOns.length && (
          <Container>
            <SeparatorVertical $margin={8} />
            <Text variant="ParagraphSmall" $style={{ color: colors.gray500 }}>
              {t('ticketOrders:add_ons')}
            </Text>
            {data.flightPurchaseAddOns.map((addon, idx) => (
              <AirlineContainer
                key={addon.id || `${parentIdx}-flightPurchaseAddOns-${idx}`}
              >
                <GuestContent>
                  <Text variant="LabelSmall">
                    {`${addon.guestName} | ${addon.description} | ${addon.route}` ||
                      ''}
                  </Text>
                  <SeparatorHorizontal $margin={8} />
                  <Text variant="LabelSmall" $style={{ color: colors.gray500 }}>
                    {`@ Rp ${string2money(addon.price || 0)}`}
                  </Text>
                </GuestContent>
                <Text variant="LabelSmall">
                  {`Rp ${string2money(addon.price || 0)}`}
                </Text>
              </AirlineContainer>
            ))}
          </Container>
        )}
        <SeparatorVertical $margin={24}>
          <div style={{ height: 1, backgroundColor: colors.gray200 }} />
        </SeparatorVertical>
      </>
    </Container>
  );
}
